import { useCallback, useEffect, useSyncExternalStore } from 'react';
import {
  subscribeChangeRequestSummary,
  getChangeRequestSummarySnapshot,
  parseChangeRequestSummarySnapshot,
  refreshChangeRequestSummary,
  enableChangeRequestSummary,
} from '../services/changeRequestSummaryStore';

/**
 * ТЗ 27: badge заявок считается только из authoritative
 * GET /admin/change-requests/summary — никогда из уже загруженной страницы
 * списка (её total зависит от фильтра статуса).
 *
 * FE-FIX11: слушатели и in-flight запрос живут в модуле-владельце, поэтому
 * сколько бы компонентов ни вызвали хук, запрос будет один.
 */
export const useChangeRequestSummary = ({ enabled = true } = {}) => {
  useEffect(() => { enableChangeRequestSummary(enabled); }, [enabled]);

  const snapshot = useSyncExternalStore(
    subscribeChangeRequestSummary,
    getChangeRequestSummarySnapshot,
    getChangeRequestSummarySnapshot
  );

  useEffect(() => {
    if (!enabled) return;
    refreshChangeRequestSummary();
  }, [enabled]);

  const refresh = useCallback(() => refreshChangeRequestSummary(), []);
  const { state, pendingCount } = parseChangeRequestSummarySnapshot(snapshot);

  return { state, pendingCount, refresh };
};

export default useChangeRequestSummary;
